import { interactiveStop, updateTimer } from '../actions/actions';

const meta = (window.__meta__ = {
  position: undefined,
  positionDelta: undefined,
  duration: undefined,
  isLive: undefined,
});

export default mw01;

function mw01(store) {
  return (next) => (action) => {
    switch (action.type) {
      /*
            case interactiveStart.type: {
              if (typeof action.payload.config === "object") {
                // well-formed object description, no further changes are required
                break;
              }

              const objectDescription = action.payload;

              fetchObjectConfig(objectDescription, store)
                .then((objectConfig) => {
                  // re-create "start" action, having object config includes
                  return interactiveStart({
                    ...objectDescription,
                    config: objectConfig
                  });
                })
                .catch((error) => {
                  console.error(error.toString(), JSON.stringify(action));
                  return appActions.appError(false, error.toString());
                })
                .then(store.dispatch);

              return action;
            }
      */

      case interactiveStop.type: {
        meta.position = meta.duration = meta.isLive = undefined;
        break;
      }

      case updateTimer.type: {
        const {
          payload,
        } = action;

        meta.position = payload.position;
        meta.positionDelta = payload.position_delta;
        meta.duration = payload.duration;
        const lag = Math.abs(payload.duration - payload.position);
        /*
            TODO: is it still possible to falsy positive `isLive` calculation at very end of object?
         */
        payload.isLive = meta.isLive = lag <= store.getState().app.config.liveThreshold;

        break;
      }

      default:
    }

    /*
     вместо примитивного идентификатора на основе видео
      нужен полноценный идентификатор объекта, URI
      с учетом пользователя, tenants
    //<tenant>?<tenants_internal_variables>
    //megogo.net?<video_id>&<channel_id>
    //combinator.megogo.dev?<project>&<service>
*/
    return next({
      ...action,
      meta: {
        ...action.meta,
        ...meta,
        objectId: store.getState().video.id,
        timestamp: Date.now(),
      },
    });
  };
}
